import styled from 'styled-components';

export const Heading = styled.h3`
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey45};
  padding-bottom: ${({ theme }) => theme.spacing.standard};
  margin-bottom: ${({ theme }) => theme.spacing.standard};
  margin-top: 0;
`;

export const Wrap = styled.div`
  background: ${({ theme }) => theme.palette.lightBackground};
  padding: ${({ theme }) => theme.spacing.standard};
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;
